import { ApplyCouponPotentialCommsType } from "@swiggy-private/cart-types";

export const isCommsTypeIPL = (type: ApplyCouponPotentialCommsType) => {
    return type === ApplyCouponPotentialCommsType.IPL_SWIGGY_SIXES;
};

export const isCommsTypeFTUE = (type: ApplyCouponPotentialCommsType) => {
    return type === ApplyCouponPotentialCommsType.FTUE;
};
